/**
 * Ritual Grid Component
 * Responsive grid of Ritual cards with infinite scroll functionality
 */

import type { RitualCardProps } from "@/components/cards/ritualCard"
import { RitualCard } from "@/components/cards/ritualCard"
import { useInfiniteScroll } from "@/hooks/useInfiniteScroll"

export interface RitualGridProps {
  rituals: RitualCardProps[]
  isLoading: boolean
  hasMore: boolean
  onLoadMore: () => void
}

export function RitualGrid({ rituals, isLoading, hasMore, onLoadMore }: RitualGridProps) {
  const loadMoreRef = useInfiniteScroll({
    onLoadMore,
    hasMore,
    threshold: 200,
  })

  return (
    <div className="md:mt-12">
      {/* Ritual Cards Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-5 md:gap-y-8">
        {rituals.map((ritual, index) => (
          <div key={index} className="h-[260px] md:h-[440px]">
            <RitualCard {...ritual} />
          </div>
        ))}
      </div>

      {/* Loading State */}
      {isLoading && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
          <div
            className="h-[440px] bg-card rounded-tl-[40px] rounded-br-[40px] animate-pulse"
            aria-hidden="true"
          />
          <div
            className="h-[440px] bg-card rounded-tl-[40px] rounded-br-[40px] animate-pulse"
            aria-hidden="true"
          />
        </div>
      )}
      {/* Sentinel for Intersection Observer */}
      {(hasMore || isLoading) && <div ref={loadMoreRef} className="h-4" aria-hidden="true" />}
    </div>
  )
}
